/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { providers } from "dc-core";

const updateETagForViewerAssetSelection = async (fileId, eTagValue) => {
    // TODO: Remove updateEtag call from rendition
    try {
        const selectionProvider = await providers.selection();
        const viewerAssetSelection = await selectionProvider.registerSelection("ViewerAsset");
        viewerAssetSelection.clearSelection();
        if (!eTagValue) return;
        viewerAssetSelection.selectItem(fileId, { eTag: eTagValue, asset_id: fileId });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error during setting etag in selection provider: ", error);
    }
};

export default updateETagForViewerAssetSelection;
